<div class="profile-dialog-backdrop" (click)="close()">
  <section #dialog class="profile-dialog" [class.profile-dialog--medium]="size === 'medium'" role="dialog" aria-modal="true" [attr.aria-labelledby]="headingId" (click)="$event.stopPropagation()" (keydown)="onKeydown($event)">
    <header>
      <div>
        @if (eyebrow) {<span class="profile-dialog__eyebrow">{{ eyebrow }}</span>}
        <h2 [id]="headingId">{{ heading }}</h2>
        @if (intro) {<p>{{ intro }}</p>}
      </div>
      <button #closeButton type="button" (click)="close()" [attr.aria-label]="closeLabel"><i class="fal fa-xmark" aria-hidden="true"></i></button>
    </header>
    <div class="profile-dialog__body"><ng-content></ng-content></div>
  </section>
</div>
